import React from 'react';

export default function Button(props) {
	const variant = props.variant;
	const color = props.color;
	const disabled = props.disabled;
	const className = props.className;

	return (
		<>
			{
				props.href && props.onClick
					?
					<a
						style={{ textDecoration: "none" }}
						href={props.href}
						target={props.target}
						onClick={(e) => disabled ? e.stopPropagation() : props.onClick()}

						data-label={props.dataLabel}
						data-category={props.dataCategory}
						data-posizione={props.dataPosizione}
						data-filiale={props.dataFiliale}
						data-linkId={props.dataLinkId}
						data-param={props.dataParam}
						disabled={disabled}
						className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
					>
						{props.children}
					</a>
					:
					<>
						{
							props.href
								?
								<a
									style={{ textDecoration: "none" }}
									href={props.href}
									disabled={disabled}
									className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
									data-label={props.dataLabel}
									data-category={props.dataCategory}
									data-posizione={props.dataPosizione}
									data-filiale={props.dataFiliale}
									data-linkId={props.dataLinkId}
									data-param={props.dataParam}
								>
									{props.children}
								</a>

								:

								<>
									{
										props.onClick ?
											<a
												onClick={(e) => disabled ? e.stopPropagation() : props.onClick()}
												disabled={disabled}
												className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
											>
												{props.children}
											</a>
											:
											<a
												disabled={disabled}
												className={(disabled ? "Mui-disabled " : " ") + "button btn " + (variant === "contained" ? "MuiButton-contained" : "") + (color === "primary" ? "Primary" : color === "secondary" ? "Secondary" : "") + " " + (variant === "outlined" ? "MuiButton-outlined" : "") + " " + color + " " + disabled + " " + className}
											>
												{props.children}
											</a>
									}
								</>
						}
					</>
			}
		</>
	);
}